<template>
  <div class="video_banner" :class="[displayStyle]">
    <video
      autoplay
      loop
      muted
      :src="videoObj.videoUrl"
      :poster="videoObj.coverUrl"
    ></video>
    <p class="title" v-if="videoObj.title">{{ videoObj.title }}</p>
  </div>
</template>

<script>
export default {
  name: "videoBanner",
  props: {
    videoObj: Object,
    displayStyle: String,
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/videoBanner/videoBanner.css);
</style>